(ns rothko.theme.manatee.form.checkbox
  (:refer-clojure :exclude [rem + - * /])
  (:require [garden.units :as units :refer [rem]]
            [rothko.theme.manatee.colours :refer [colours]]))

(def checkbox
  {:right-label {:display :flex
                 :flex-direction :row-reverse
                 :message-color (:red-dark colours)
                 :message-order -1
                 :message-padding [[(rem 0.5) 0 0 (rem 1)]]}})
